import type { RouteRecordRaw } from 'vue-router';
import miniRoutes from '@/router/routes/mini';
import immerseRoutes from '@/router/routes/immerse';
import gameRoutes from '@/router/routes/game';
import t5configRoutes from '@/router/routes/t5config';
import x5configRoutes from '@/router/routes/x5config';
import s6configRoutes from '@/router/routes/s6config';
import c6configRoutes from '@/router/routes/c6config';
import wikiRoutes from '@/router/routes/wiki';
import platformRoutes from '@/router/routes/platformMember';
import activityTemplateRoutes from '@/router/routes/activityTemplate';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@h5-monorepo/shared/components/404.vue'),
    beforeEnter: () => {
      window.location.replace('https://docoi.cc');
    }
  },
  {
    path: '/invite/juDCzpboH',
    name: 'Invite',
    component: () => import('@/views/h5/Invite.vue')
  },
  {
    path: '/share/juDCzpboH',
    name: 'Share',
    component: () => import('@/views/h5/Share.vue')
  },
  {
    path: '/gameInvite',
    name: 'gameInvite',
    component: () => import('@/views/h5/GameInvite.vue'),
    children: [
      {
        path: '',
        name: 'gameInviteTest',
        component: () => import('@/views/h5/GameInvite.vue')
      },
      {
        path: ':inviteCode',
        name: 'gameInviteCode',
        component: () => import('@/views/h5/GameInvite.vue')
      }
    ]
  },
  {
    path: '/contrastActivity/postingRules',
    name: 'ContrastPostingRules',
    component: () => import('@/views/contrastActivity/postingRules.vue'),
    meta: {
      title: '反转动态发帖规范'
    }
  },
  {
    path: '/c/:invitestring',
    name: 'CircleShare',
    component: () => import('@/views/h5/CircleShare.vue'),
    meta: {
      userSource: 'circleShare'
    }
  },
  {
    path: '/h5/appdown',
    name: 'CircleShAppDownloadare',
    component: () => import('@/views/h5/AppDownload.vue'),
    meta: {
      userSource: 'downloadPage2'
    }
  },
  {
    path: '/h5/dynamicshare/:dynamicid',
    name: 'DynamicShare',
    component: () => import('@/views/dynamicShare/index.vue'),
    meta: {
      userSource: 'dynamicShare'
    }
  },
  {
    path: '/h5/joinGroupChat/:serverId/:joinId',
    name: 'JoinGroupChat',
    component: () => import('@/views/h5/JoinGroupChat.vue'),
    meta: {
      userSource: 'joinGroupChat'
    }
  },
  {
    path: '/h5/redeemcode/:serverId/:isAppShare?',
    name: 'redeemCodeShare',
    component: () => import('@/views/h5/redeemCodeShare.vue'),
    meta: {
      userSource: 'redeemCodeShare',
      layout: 'share'
    }
  },
  {
    path: '/h5/lottery/:id',
    name: 'lottery',
    component: () => import('@/views/h5/lotteryActivity/index.vue'),
    meta: {
      title: '转盘活动'
    }
  },
  {
    path: '/h5/lottery-preview',
    name: 'lotteryPreview',
    component: () => import('@/views/h5/lotteryPreview.vue'),
    meta: {
      title: '转盘活动预览'
    }
  },
  {
    path: '/h5/game_welfare/:server_id',
    name: 'game_welfare',
    component: () => import('@/views/h5/game_welfare.vue'),
    meta: {
      title: '官方社区专属福利',
      userSource: 'gameWelfare'
    }
  },
  {
    path: '/h5/battleServeBind',
    name: 'battleServeBind',
    component: () => import('@/views/h5/battleServeBind.vue'),
    meta: {
      title: '账号绑定'
    }
  },
  {
    path: '/h5/dyAppServerBind',
    name: 'dyAppServerBind',
    component: () => import('@/views/h5/dyAppServerBind.vue'),
    meta: {
      title: '账号绑定'
    }
  },
  {
    path: '/debug/ad-video',
    name: 'adVideo',
    component: () => import('@/views/debug/adVideo.vue'),
    meta: {
      title: 'showAdVideo 调试'
    }
  },
  {
    path: '/h5/scheme-builder',
    name: 'schemeBuilder',
    component: () => import('@/views/debug/schemeBuilder.vue'),
    meta: {
      title: 'URL Scheme 跳转调试'
    }
  },
  {
    path: '/charmExplain',
    name: 'charmExplain',
    component: () => import('@/views/h5/CharmExplain.vue'),
    meta: {
      title: '魅力值说明'
    }
  },
  {
    path: '/annual-report/2025/auth-agreement',
    name: '2025AuthAgreement',
    component: () => import('@/views/annualReport/2025/authAgreement.vue'),
    meta: {
      title: '用户授权协议'
    }
  },
  {
    path: '/share',
    name: 'gameMall',
    redirect: '/immerse/game-mall'
  },
  {
    path: '/longEssay/dynamic/preview',
    name: 'longEssay_dynamic_preview',
    component: () => import('@/views/longEssay/preview.vue')
  },
  {
    path: '/longEssay/dynamic/:id',
    name: 'longEssay_dynamic',
    component: () => import('@/views/longEssay/index.vue')
  },
  {
    path: '/gameVip/:serverId',
    name: 'gameVip',
    component: () => import('@/views/vip/index.vue')
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('@/views/h5/versionUpgrade.vue')
  },
  {
    path: '/wjx/survey',
    name: 'survey',
    component: () => import('@/views/wjx/survey.vue'),
    meta: {
      title: '问卷调查'
    }
  },
  {
    path: '/customerTool/:gid',
    name: 'customer_tool',
    component: () => import('@/views/customerTool/customerTool.vue'),
    meta: {
      title: '升级服务'
    }
  },
  {
    path: '/lp',
    name: 'landingPage',
    children: [
      {
        path: 'sf/:id',
        name: 'landingPage_sf',
        component: () => import('@/views/landingPage/springFestival.vue'),
        meta: {
          title: '新春福利'
        }
      }
    ]
  },
  {
    path: '/link/expired',
    name: 'linkExpired',
    component: () => import('@/views/h5/linkExpired.vue'),
    meta: {
      title: '梦游社-链接已失效'
    }
  },
  ...miniRoutes,
  ...immerseRoutes,
  ...gameRoutes,
  ...t5configRoutes,
  ...x5configRoutes,
  ...s6configRoutes,
  ...c6configRoutes,
  ...wikiRoutes,
  ...platformRoutes,
  ...activityTemplateRoutes
];

export default routes;
